import { EpimsBaseEntityDto } from './epim-base.dto';

export class PigibilityDto extends EpimsBaseEntityDto{
  PigibilityName: string;
  SubscriptionUserId: string;
  }
